const handleDeleteCompanyFormCompany = {
  text: 'Do you really want to delete this company?',
  title: 'DELETE COMPANY',
};

export default handleDeleteCompanyFormCompany;
